import {PureComponent} from 'react'
import { format } from 'date-fns'
import {Button} from 'reactstrap'

import Loader from '../../../../../shared/components/Loader/Loader.jsx'
import FormGlobalErrors from '../../../../components/Form/FormGlobalErrors.jsx'
import AdditionalInfoForm from '../../../../components/Forms/AdditionalInfoForm/AdditionalInfoForm.jsx'
import RemoveModal from '../../../../../shared/components/Modals/RemoveModal/RemoveModal.jsx'
import SubmitButton from '../../../../components/Forms/AdditionalInfoForm/SubmitButton.jsx'

import {prepareFreelanceBeforeSubmit} from '../../../../../shared/services/freelanceService'
import {prepareUserBeforeSubmit} from '../../../../../shared/services/userService'

import connectModal from '../../../../../shared/components/Modals/connect.js'
import conf from '../../../../conf.js'
import {generate} from '../../../../routes.js'

import './AdditionalInfo.scss'
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"

class AdditionalInfo extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      errors: null
    }
  }

  submit = (values) => {
    this.props.submit({
      user: prepareUserBeforeSubmit(values.user),
      freelance: prepareFreelanceBeforeSubmit(values.freelance)
    })
  }

  openRemoveModal = () => {
    this.props.openRemoveModal({
      user: this.props.user,
      onHardDelete: () => {
        window.location = generate({
          name: 'homepage',
          search: {action: 'confirmDeletion'}
        })
      },
      onLongTermContractUpdated: (hasLongTermContract) => this.props.submit({
        freelance: {
          ...prepareFreelanceBeforeSubmit(this.props.freelance),
          cdi: true,
        },
        user: prepareUserBeforeSubmit(this.props.user)
      }),
    })
  }

  render() {
    const {freelance, ...props} = this.props

    const initialValues = {
      user: props.user,
      freelance: {
        ...freelance,
        work_permit: freelance?.work_permit ?? conf.workPermits.european.value,
        situation: freelance?.situation ?? conf.situations.permanentContract.value,
        date_available: freelance?.date_available ?? format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
        part_time: freelance?.part_time ?? conf.partTime.all.value,
      },
    }

    return(
      <FreelancePage className="additional-info">
        <h2 className="text-center">Informations complémentaires</h2>
        <div className="text-center mb-5">
        Renseignez ici vos informations de disponibilité, mobilité et préférences de missions.
        </div>
        <FormGlobalErrors errors={this.state.errors} />
        <AdditionalInfoForm
          enableReinitialize={true}
          onSubmit={this.submit}
          onSubmitSuccess={props.onFormSuccess}
          initialValues={initialValues}
        />
        <div className="mt-5 d-flex justify-content-between">
          <Button color="danger" onClick={this.openRemoveModal}>Supprimer mon compte</Button>
          <SubmitButton className="btn btn-primary">Sauvegarder</SubmitButton>
        </div>
        <Loader visible={this.state.loading}>Sauvegarde des informations...</Loader>
      </FreelancePage>)
  }
}

export default connectModal({RemoveModal}, AdditionalInfo)
